export default __webpack_public_path__ + "static/media/TN.878a7338.svg";